import { TapiConfig } from './base';

export const getProductionConfig: (base: TapiConfig) => TapiConfig = (base) =>
  base;
